import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { userLigaLst } from 'src/app/models/userLst';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { EditHorariosDeportistaComponent } from '../index-deportistas/edit-horarios-deportista/edit-horarios-deportista.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-index-seleccion-liga',
  templateUrl: './index-seleccion-liga.component.html',
  styleUrls: ['./index-seleccion-liga.component.scss']
})
export class IndexSeleccionLigaComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  public lstDisciplinas: any;
  public disciplinaSelect: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public userSvc: UserService,
    public disciplinaSvc: DisciplinaService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: userLigaLst[] = [];
    this.displayedColumns = [
      'nombre',
      'email',
      'documento',
      'disciplina',
      'enLiga',
      'botones',
    ];

    this.dataSource = new MatTableDataSource<userLigaLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getUsers(0, 10);

    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
    });
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getUsers(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.userSvc
      .getDeportistasLiga(page, numReg, this.searchString, this.disciplinaSelect)
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<userLigaLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;

      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getUsers(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getUsers(0, 10);
  }

  cambioDiscipinaBuscar() {
    this.getUsers(this.pageIndex, this.pageSize);
  }

  editHorariosUsuario(obj: any) {
    console.log(obj);
    obj.filtroEmpresa=false;
    let dialogRef = this.dialog.open(EditHorariosDeportistaComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getUsers(this.pageIndex, this.pageSize);
      }
    });
  }

  onToggle(ob: MatSlideToggleChange, elemento: any) {
    console.log(ob.checked);
    console.log(elemento);

     this.userSvc
      .editarEstadoLiga({ id:elemento.id,  estado:ob.checked})
      .subscribe((result) => {
        if (result) {
          elemento.asignado = ob.checked;
        } else {
          console.log('error al cambiar de estado');
        }
      }); 
  }
}
